import React, { useState, useEffect } from "react";
import Form from "../components/Form";
import { motion } from "framer-motion";
import Logo from "../images/logo.png";
import "../App.css";

// Hero images
import Hero1 from "../images/hero-1.png";
import Hero2 from "../images/hero-2.png";
import Hero3 from "../images/hero-3.png";

import AboutImg from "../images/about.png";

// Sample Floor Plan Images (replace with your actual images)
import PlanAC1 from "../images/ac-1.png";
import PlanAC2 from "../images/ac-2.png";
import PlanAC3 from "../images/ac-3.jpg";
import PlanAC4 from "../images/ac-4.jpg";
import PlanAC5 from "../images/ac-5.jpg";
import PlanB1 from "../images/b-1.jpg";
import PlanB2 from "../images/b-2.jpg";
import PlanB3 from "../images/b-3.jpg";
import PlanB4 from "../images/b-4.jpg";
import PlanB5 from "../images/b-5.jpg";

// Gallery Images - Import your local files
import Gallery1 from "../images/Screenshot 2025-12-12 125337.png";
import Gallery2 from "../images/Screenshot 2025-12-12 125409.png";
import Gallery3 from "../images/Screenshot 2025-12-12 125429.png";
import Gallery4 from "../images/Screenshot 2025-12-12 125449.png";
import Gallery5 from "../images/Screenshot 2025-12-12 125511.png";
import Gallery6 from "../images/Screenshot 2025-12-12 125606.png";
import Gallery7 from "../images/about.png";
import Gallery8 from "../images/hero-1.png";
import Gallery9 from "../images/hero-2.png";
import Gallery10 from "../images/hero-3.png";
import Gallery11 from "../images/7.jpg";
import Gallery12 from "../images/21.jpg";
import ContactImage from "../images/Screenshot 2025-12-12 125409.png"; // Left side image
import ContactBg from "../images/7.jpg"; // Full background image

const heroImages = [Hero1, Hero2, Hero3];

export default function Home({ onOpenForm }) {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isScrolled, setIsScrolled] = useState(false); // Track scroll state

  // Auto-slide
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  // Detect scroll to apply glassy effect
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100); // Trigger after scrolling 100px
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Inside your Home component
  const [activeTab, setActiveTab] = useState("All");

  // Clean data with unique IDs
  const floorPlans = [
    {
      id: 1,
      category: "AC",
      title: "Encanto Puppalaguda luxury homes with world-class amenities in Hyderabad",
      area: "1,850 sqft",
      bedrooms: 3,
      bathrooms: 3,
      image: PlanAC1,
    },
    {
      id: 2,
      category: "AC",
      title: "Encanto by Lansum MK Realty contemporary apartment design in Hyderabad",
      area: "2,100 sqft",
      bedrooms: 3,
      bathrooms: 4,
      image: PlanAC2,
    },
    {
      id: 3,
      category: "AC",
      title: "Encanto Hyderabad high-rise luxury living near ORR and Financial District",
      area: "2,300 sqft",
      bedrooms: 4,
      bathrooms: 4,
      image: PlanAC3,
    },
    {
      id: 4,
      category: "AC",
      title: "Encanto Puppalaguda ultra-luxury residential project by Lansum MK Realty", // Changed to A4 or another variant
      area: "2,300 sqft",
      bedrooms: 4,
      bathrooms: 4,
      image: PlanAC4,
    },
    {
      id: 5,
      category: "AC",
      title: "Encanto by Lansum & MK Realty premium clubhouse and lifestyle amenities", // A5 variant
      area: "2,300 sqft",
      bedrooms: 4,
      bathrooms: 4,
      image: PlanAC5,
    },
    {
      id: 6,
      category: "B",
      title: "Encanto Hyderabad skyline view luxury apartments near Financial District",
      area: "1,450 sqft",
      bedrooms: 2,
      bathrooms: 2,
      image: PlanB1,
    },
    {
      id: 7,
      category: "B",
      title: "Luxury 3 and 4 BHK apartments at Encanto Puppalaguda Hyderabad",
      area: "1,600 sqft",
      bedrooms: 2,
      bathrooms: 3,
      image: PlanB2,
    },
    {
      id: 8,
      category: "B",
      title: "Encanto by Lansum MK Realty modern luxury residences in Puppalaguda Hyderabad",
      area: "1,800 sqft",
      bedrooms: 3,
      bathrooms: 3,
      image: PlanB3,
    },
    {
      id: 9,
      category: "B",
      title: "Encanto Hyderabad premium high-rise apartments near ORR by Lansum MK Realty", // B4 variant
      area: "1,800 sqft",
      bedrooms: 3,
      bathrooms: 3,
      image: PlanB4,
    },
    {
      id: 10,
      category: "B",
      title: "Encanto by Lansum & MK Realty luxury apartments in Puppalaguda Financial District Hyderabad", // B5 variant
      area: "1,800 sqft",
      bedrooms: 3,
      bathrooms: 3,
      image: PlanB5,
    },
  ];

  // CORRECTED Filter Logic
  const filteredPlans = floorPlans.filter((plan) => {
    if (activeTab === "All") return true;

    if (activeTab === "Tower AC") return plan.category === "AC";
    if (activeTab === "Tower B") return plan.category === "B";

    return false; // fallback
  });

  //   Gallery
  const galleryImages = [
    {
      src: Gallery1,
      caption: "Encanto by Lansum & MK Realty iconic tower exterior in Puppalaguda Hyderabad"
    },
    {
      src: Gallery2,
      caption: "Encanto by Lansum & MK Realty modern luxury apartment facade in Puppalaguda"
    },
    {
      src: Gallery3,
      caption: "Encanto by Lansum & MK Realty luxury living room in Puppalaguda apartments"
    },
    {
      src: Gallery4,
      caption: "Encanto by Lansum & MK Realty master bedroom in luxury apartments Puppalaguda"
    },
    {
      src: Gallery5,
      caption: "Encanto by Lansum & MK Realty rooftop infinity pool luxury apartments Hyderabad"
    },
    {
      src: Gallery6,
      caption: "Encanto by Lansum & MK Realty premium clubhouse amenities in Puppalaguda"
    },
    {
      src: Gallery7,
      caption: "Encanto by Lansum & MK Realty state-of-the-art gym in luxury apartments Hyderabad"
    },
    {
      src: Gallery8,
      caption: "Encanto by Lansum & MK Realty biophilic terrace gardens in Puppalaguda"
    },
    {
      src: Gallery9,
      caption: "Encanto by Lansum & MK Realty grand lobby entrance luxury apartments Hyderabad"
    },
    {
      src: Gallery10,
      caption: "Encanto by Lansum & MK Realty exclusive sky lounge luxury living Hyderabad"
    },
    {
      src: Gallery11,
      caption: "Encanto by Lansum & MK Realty wellness spa in luxury apartments Puppalaguda"
    },
    {
      src: Gallery12,
      caption: "Encanto by Lansum & MK Realty landscaped terrace in luxury apartments Hyderabad"
    }
  ];


  //  FAQ's
  const faqs = [
    {
      icon: "fa-map-marker-alt",
      question: "Where is Encanto located?",
      answer:
        "Encanto is strategically located in the city's premier power corridor, offering seamless connectivity to business districts, entertainment hubs, and major transportation networks.",
    },
    {
      icon: "fa-building",
      question: "What types of residences are available?",
      answer:
        "We offer thoughtfully designed 2, 3, and 4-bedroom luxury apartments across AC Tower and B Tower, ranging from 1,050 to 2,300 sqft, each with premium finishes and panoramic views.",
    },
    {
      icon: "fa-swimmer",
      question: "What amenities does the project offer?",
      answer:
        "Residents enjoy world-class facilities including a rooftop infinity pool, state-of-the-art gym, wellness spa, clubhouse, sky lounge, biophilic terraces, concierge services, and 24/7 security.",
    },
    {
      icon: "fa-clock",
      question: "When is the expected completion date?",
      answer:
        "The project is slated for completion in Q4 2027, with phased possession starting from mid-2027. Early buyers may benefit from priority unit selection.",
    },
    {
      icon: "fa-shield-alt",
      question: "What security features are in place?",
      answer:
        "Encanto features multi-layered security with 24/7 CCTV surveillance, biometric access control, trained security personnel, and secure parking with valet services.",
    },
    {
      icon: "fa-envelope",
      question: "How can I book a unit or schedule a site visit?",
      answer:
        "Simply click the 'Enquire Now' button on any page or fill out the contact form. Our sales team will promptly arrange a personalized site visit and provide detailed brochures and pricing.",
    },
  ];

  // Whatsapp config
  const whatsappNumber = "+919652389333"; // replace with your number (country code included, no +)
  const whatsappMessage = encodeURIComponent(
    "I am interested in NOVA, Financial District Project, please share details"
  );
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;

  return (
    <>
      {/* ==================== HEADER - Transparent → Glassy on Scroll ==================== */}
      <header
        className={`fixed-top transition-all ${isScrolled ? "glassy-header" : "transparent-header"
          }`}
        style={{ zIndex: 1030 }}
      >
        <nav className="container py-2 d-flex justify-content-between align-items-center">
          {/* Logo */}
          <a href="/" className="d-flex align-items-center">
            <img
              src={Logo}
              alt="Encanto by Lansum & MK Realty luxury apartments in Puppalaguda Financial District Hyderabad"
              className="img-fluid drop-shadow"
              style={{ width: "160px" }}
            />
          </a>

          {/* Desktop Nav */}
          <ul className="d-none d-lg-flex gap-4 list-unstyled m-0 align-items-center">
            {[
              "Home",
              "About",
              "Amenities",
              "Floor Plans",
              "Gallery",
              "Contact",
            ].map((item) => (
              <li key={item}>
                <a
                  href={`#${item.toLowerCase().replace(" ", "")}`}
                  className="nav-link text-white drop-shadow"
                >
                  {item}
                </a>
              </li>
            ))}
          </ul>

          {/* Desktop Enquire Button - Only on large screens */}
          <button
            className="btn btn-main px-5 py-2 d-none d-lg-block drop-shadow fw-bold"
            onClick={onOpenForm}
          >
            Enquire Now
          </button>

          {/* Mobile Hamburger - Always visible on < lg screens */}
          <button
            className="btn text-white fs-1 d-lg-none drop-shadow border-0 bg-transparent p-0"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#mobileMenu"
            aria-controls="mobileMenu"
            style={{ filter: "drop-shadow(2px 2px 4px rgba(0,0,0,0.8))" }}
          >
            <i className="bi bi-list"></i>
          </button>
        </nav>

        {/* Mobile Offcanvas Menu */}
        <div
          className="offcanvas offcanvas-end bg-black text-white"
          tabIndex="-1"
          id="mobileMenu"
          aria-labelledby="mobileMenuLabel"
        >
          <div className="offcanvas-header border-bottom border-secondary">
            <h5 className="m-0" id="mobileMenuLabel">
              Menu
            </h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>
          <div className="offcanvas-body pt-4">
            <ul className="list-unstyled mb-5">
              {[
                "Home",
                "About",
                "Amenities",
                "Floor Plans",
                "Gallery",
                "Contact",
              ].map((item) => (
                <li key={item} className="mb-2">
                  <a
                    href={`#${item.toLowerCase().replace(" ", "")}`}
                    data-bs-dismiss="offcanvas"
                    className="d-block py-3 text-white text-decoration-none fs-5 fw-medium hover-text-main transition-all"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>

            <button
              className="btn btn-main w-100 py-3 fw-bold text-uppercase"
              onClick={onOpenForm}
              data-bs-dismiss="offcanvas"
            >
              Enquire Now
            </button>
          </div>
        </div>
      </header>

      {/* ==================== HERO SLIDER SECTION ==================== */}
      <section
        className="hero-slider position-relative d-flex align-items-center"
        style={{ minHeight: "100vh", paddingTop: "90px" }} // Extra padding for fixed header
      >
        {/* Slides */}
        {heroImages.map((img, index) => (
          <div
            key={index}
            className="hero-slide position-absolute top-0 start-0 w-100 h-100"
            style={{
              backgroundImage: `url(${img})`,
              opacity: currentSlide === index ? 1 : 0,
              transition: "opacity 1.5s ease-in-out",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            {/* ✅ SEO Image (Invisible but indexable) */}
            <img
              src={img}
              alt="Encanto by Lansum & MK Realty luxury apartments in Puppalaguda Financial District Hyderabad"
              loading="eager"
              className="seo-hidden-img"
            />
          </div>
        ))}


        <div className="hero-overlay"></div>

        {/* Content */}
        <div className="container position-relative" style={{ zIndex: 2 }}>
          <div className="row align-items-center">
            <div className="col-lg-7 text-white">
              <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.6 }}
              >
                <h1 className="display-5 fw-bold mb-4 drop-shadow-text text-main">
                  Encanto by Lansum & MK Realty – Ultra Luxury Apartments in Hyderabad
                </h1>
                {/* <p className="lead mb-4 drop-shadow-text">
                  Bold lines. Sharp edges. Unmistakably iconic — Encanto at the
                  city's power corridor.
                </p> */}

                <div className="mt-5">
                  <button
                    className="btn btn-outline-light me-3 px-4 py-2 drop-shadow"
                    onClick={onOpenForm}
                  >
                    <i className="fa fa-envelope text-main me-2"></i>Enquire
                  </button>
                  <a className="btn btn-main px-4 py-2" href="#floorplans">
                    View Floorplans
                  </a>
                </div>
              </motion.div>
            </div>

            <div className="col-lg-5 d-none d-lg-block">
              <motion.div
                className="bg-dark bg-opacity-75 p-5 rounded-4 shadow-lg"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.6 }}
              >
                <h4 className="fw-bold text-white mb-3">Enquire Now</h4>

                <Form
                  type="full"
                  onSuccess={() => {
                    alert(
                      "Thank you! Your enquiry has been submitted. We'll contact you soon."
                    );
                  }}
                />

                <hr className="border-secondary opacity-25 my-4" />

                <div className="text-center">
                  <p className="text-white-50 mb-2">
                    Speak to our sales team directly:
                  </p>
                  <h5 className="text-white fw-bold">
                    <i className="fa fa-phone me-3 text-main"></i>
                    <a
                      href="tel:+919652389333"
                      className="text-white text-decoration-none hover-underline"
                    >
                      +91 96523 89333
                    </a>
                  </h5>
                </div>
              </motion.div>
            </div>
          </div>
        </div>

        {/* Indicators */}
        <div className="slide-indicators position-absolute bottom-0 start-50 translate-middle-x mb-4">
          {heroImages.map((_, index) => (
            <span
              key={index}
              className={`dot ${currentSlide === index ? "active" : ""}`}
              onClick={() => setCurrentSlide(index)}
            />
          ))}
        </div>
      </section>

      {/* Main Content */}
      <main className="bg-black">
        {/* Small Contact */}

        <div className="container-fluid d-lg-none d-block mt-4">
          <div className="row justify-content-center">
            <div className="col-md-8 col-12">
              <motion.div
                className="bg-dark bg-opacity-75 p-5 rounded-4 shadow-lg"
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.6 }}
              >
                <h4 className="fw-bold text-white mb-3">Enquire Now</h4>

                <Form
                  type="full"
                  onSuccess={() => {
                    alert(
                      "Thank you! Your enquiry has been submitted. We'll contact you soon."
                    );
                  }}
                />

                <hr className="border-secondary opacity-25 my-4" />

                <div className="text-center">
                  <p className="text-white-50 mb-2">
                    Speak to our sales team directly:
                  </p>
                  <h5 className="text-white fw-bold">
                    <i className="fa fa-phone me-3 text-main"></i>
                    <a
                      href="tel:+919652389333"
                      className="text-white text-decoration-none hover-underline"
                    >
                      +91 96523 89333
                    </a>
                  </h5>
                </div>
              </motion.div>
            </div>
          </div>
        </div>

        {/* About */}
        {/* ------------------- ABOUT SECTION ------------------- */}
        <section id="about" className="py-5">
          <div className="container">
            <div className="row align-items-center g-5">
              {/* LEFT — IMAGE */}
              <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7 }}
                className="col-lg-6"
              >
                <img
                  src={AboutImg}
                  alt="Encanto by Lansum & MK Realty luxury apartments in Puppalaguda Hyderabad"
                  className="img-fluid rounded-4 shadow-lg"
                />
              </motion.div>

              {/* RIGHT — CONTENT WRAPPER */}
              <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7 }}
                className="col-lg-6"
              >
                {/* Title */}
                <motion.h2
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.7, delay: 0.1 }}
                  className="fw-bold display-6 mb-3 text-main"
                >
                  Premium 3 & 4 BHK Homes in Puppalaguda, Financial District
                </motion.h2>

                {/* Subtext */}
                <motion.p
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.7, delay: 0.15 }}
                  className=" mb-4"
                >
                  Bold lines. Sharp edges. Unmistakably iconic — Encanto stands
                  tall at the city’s power corridor, where movement meets
                  momentum.
                </motion.p>

                {/* Description */}
                <motion.p
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.7, delay: 0.2 }}
                  className=" mb-4"
                >
                  Crafted for those who rise with purpose, Encanto brings a
                  sculptural geometry to modern living. Every element is
                  thoughtfully curated — designed outside in and experienced
                  inside out — delivering a premium vertical community unlike
                  any other in the city.
                </motion.p>

                {/* Bullet Points */}
                <ul className="list-unstyled mb-4">
                  {[
                    "Homes that rise with purpose and precision",
                    "Direct access to basements for a vehicle-free podium",
                    "Designed outside-in, experienced inside-out",
                    "Vertical, biophilic leisure experiences",
                  ].map((item, index) => (
                    <motion.li
                      key={index}
                      initial={{ opacity: 0, y: 40 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.7, delay: 0.25 + index * 0.1 }}
                      className="mb-2 d-flex"
                    >
                      <i className="fa fa-check-circle text-main me-2"></i>
                      {item}
                    </motion.li>
                  ))}
                </ul>

                {/* Button */}
                <motion.button
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.7, delay: 0.6 }}
                  className="btn btn-main px-4 py-2"
                  onClick={onOpenForm}
                >
                  Enquire Now
                </motion.button>
              </motion.div>
            </div>
          </div>
        </section>

        {/* Key Highlights */}
        {/* ==================== PROJECT HIGHLIGHTS SECTION ==================== */}
        <section id="highlights" className="py-5 bg-black text-white">
          <div className="container">
            <div className="text-center mb-5">
              <h2 className="display-5 fw-bold mb-3">Project Highlights</h2>
              <p className="">
                Discover the key highlights of Encanto by Lansum & MK Realty, a premium residential development in Puppalaguda, Hyderabad, offering thoughtfully designed luxury apartments with world-class amenities, superior architecture, and excellent connectivity to the Financial District and ORR.
              </p>
            </div>

            <div className="row g-4">
              {[
                {
                  icon: "fa-building",
                  title: "Prime Location",
                  desc: "Strategically positioned in the city's power corridor with seamless connectivity.",
                },
                {
                  icon: "fa-shield-alt",
                  title: "24/7 Security",
                  desc: "Advanced multi-layer security systems ensuring complete peace of mind.",
                },
                {
                  icon: "fa-swimmer",
                  title: "Infinity Pool",
                  desc: "Stunning rooftop infinity pool offering panoramic city skyline views.",
                },
                {
                  icon: "fa-dumbbell",
                  title: "State-of-the-Art Gym",
                  desc: "Fully equipped fitness center with premium equipment and personal trainers.",
                },
                {
                  icon: "fa-tree",
                  title: "Biophilic Design",
                  desc: "Vertical gardens and green terraces blending nature with urban luxury.",
                },
                {
                  icon: "fa-concierge-bell",
                  title: "Concierge Services",
                  desc: "Dedicated concierge for lifestyle management and exclusive resident privileges.",
                },
              ].map((highlight, index) => (
                <div key={index} className="col-md-6 col-lg-4">
                  <div className="card bg-dark bg-opacity-75 border-0 text-white p-5 rounded-4 text-center hover-lift h-100">
                    <i
                      className={`fa ${highlight.icon} fa-3x mb-4 text-main`}
                    ></i>
                    <h4 className="fw-bold mb-3">{highlight.title}</h4>
                    <p className="small text-white-50">{highlight.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ==================== FLOOR PLANS SECTION ==================== */}
        <section id="floorplans" className="py-5 bg-black text-white">
          <div className="container">
            <div className="text-center mb-5">
              <h2 className="display-5 fw-bold mb-3">Floor Plans</h2>
              <p className="">
                Encanto by Lansum & MK Realty offers thoughtfully designed 3 and 4 BHK luxury apartment floor plans in Puppalaguda, Hyderabad. Each layout crafted to maximize space, ventilation, and privacy, making Encanto one of the most spacious premium residential projects near the Financial District.
              </p>
            </div>

            {/* Category Tabs - Only All, AC Tower, B Tower */}
            <ul className="nav nav-tabs justify-content-center mb-5 border-0 gap-3">
              {["All", "Tower AC", "Tower B"].map((tab) => (
                <li className="nav-item" key={tab}>
                  <button
                    className={`nav-link text-white fw-bold px-5 py-3 rounded-pill ${activeTab === tab ? "active" : ""
                      }`}
                    onClick={() => setActiveTab(tab)}
                  >
                    {tab}
                  </button>
                </li>
              ))}
            </ul>
            {/* Floor Plans Grid */}
            <div className="row g-4">
              {filteredPlans.map((plan) => (
                <div key={plan.id} className="col-md-6 col-lg-3">
                  <div className="floorplan-card position-relative overflow-hidden rounded-4 shadow-lg">
                    {/* Image */}
                    <img
                      src={plan.image}
                      alt={plan.title}
                      className="w-100 floorplan-img"
                      style={{
                        height: "380px",
                        objectFit: "cover",
                        display: "block",
                      }}
                    />

                    {/* Overlay + Button */}
                    <div className="floorplan-overlay">
                      <button
                        className="btn btn-main btn-lg px-5 py-3 shadow"
                        onClick={onOpenForm}
                        style={{ zIndex: 10 }}
                      >
                        Enquire Now
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Optional: Empty state if no plans (won't happen with current data) */}
            {filteredPlans.length === 0 && (
              <div className="text-center py-5">
                <p className="lead">
                  No floor plans available in this category yet.
                </p>
              </div>
            )}
          </div>
        </section>

        {/* ==================== AMENITIES SECTION WITH MOTION ==================== */}
        <section id="amenities" className="py-5 bg-black text-white">
          <div className="container">
            {/* Title Animation */}
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.8 }}
              className="text-center mb-5"
            >
              <h3 className="display-5 fw-bold mb-3">
                World-Class Amenities at Encanto Hyderabad
              </h3>
              <p className="">
                Encanto offers a curated collection of lifestyle amenities designed to enhance comfort, wellness, and recreation, making it one of the most sought-after luxury apartment projects in Puppalaguda, Hyderabad.
              </p>
            </motion.div>

            {/* Amenities Grid with Staggered Animation */}
            <motion.div
              className="row g-4"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-100px" }}
              variants={{
                hidden: { opacity: 0 },
                visible: {
                  opacity: 1,
                  transition: { staggerChildren: 0.15 },
                },
              }}
            >
              {[
                {
                  icon: "fa-home",
                  title: "Clubhouse",
                  desc: "Elegant social hub for gatherings",
                },
                {
                  icon: "fa-tree",
                  title: "Upper & Lower Terrace",
                  desc: "Lush green relaxation zones",
                },
                {
                  icon: "fa-water",
                  title: "Infinity Pool",
                  desc: "Rooftop pool with panoramic views",
                },
                {
                  icon: "fa-dumbbell",
                  title: "Gym & Spa",
                  desc: "State-of-the-art fitness & wellness",
                },
                {
                  icon: "fa-couch",
                  title: "Sky Lounge",
                  desc: "Exclusive high-rise relaxation area",
                },
                {
                  icon: "fa-concierge-bell",
                  title: "Concierge Service",
                  desc: "24/7 personalized assistance",
                },
                {
                  icon: "fa-shield-alt",
                  title: "Advanced Security",
                  desc: "Multi-layer protection & access control",
                },
                {
                  icon: "fa-spa",
                  title: "Wellness Spa",
                  desc: "Sauna, steam & massage facilities",
                },
                {
                  icon: "fa-leaf",
                  title: "Biophilic Gardens",
                  desc: "Vertical gardens & green spaces",
                },
                {
                  icon: "fa-car",
                  title: "Valet Parking",
                  desc: "Dedicated secure parking",
                },
                {
                  icon: "fa-dog",
                  title: "Pet Spa",
                  desc: "Grooming station for your companions",
                },
                {
                  icon: "fa-wifi",
                  title: "High-Speed WiFi",
                  desc: "Throughout all common areas",
                },
              ].map((amenity, index) => (
                <motion.div
                  key={index}
                  className="col-md-4 col-lg-3 col-6"
                  variants={{
                    hidden: { opacity: 0, y: 60, scale: 0.9 },
                    visible: { opacity: 1, y: 0, scale: 1 },
                  }}
                >
                  <motion.div
                    className="amenity-card p-5 rounded-4 text-center h-100"
                    whileHover={{
                      y: -15,
                      scale: 1.05,
                      boxShadow: "0 25px 50px rgba(0,0,0,0.6)",
                    }}
                    transition={{ duration: 0.4 }}
                  >
                    <i
                      className={`fa ${amenity.icon} fa-3x mb-4 text-main`}
                    ></i>
                    <h4 className="fw-bold mb-3">{amenity.title}</h4>
                    <p className="small text-white-50">{amenity.desc}</p>
                  </motion.div>
                </motion.div>
              ))}
            </motion.div>
          </div>
        </section>

        {/* ==================== GALLERY SECTION WITH MOTION ==================== */}
        <section id="gallery" className="py-5 bg-black text-white">
          <div className="container">
            {/* Title */}
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="text-center mb-5"
            >
              <h3 className="display-5 fw-bold mb-3">Gallery</h3>
              <p className="">
                The project gallery of Encanto by Lansum & MK Realty showcases the architectural excellence, luxury interiors, landscaped terraces, world-class amenities offered at this premium residential development in Puppalaguda, Hyderabad.
              </p>
            </motion.div>

            {/* Masonry-style Grid */}
            <motion.div
              className="row g-4"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-100px" }}
              variants={{
                hidden: { opacity: 0 },
                visible: {
                  opacity: 1,
                  transition: { staggerChildren: 0.1 },
                },
              }}
            >
              {galleryImages.map((img, index) => (
                <motion.div
                  key={index}
                  className="col-12 col-sm-6 col-lg-4 col-xl-3"
                  variants={{
                    hidden: { opacity: 0, y: 50, scale: 0.9 },
                    visible: { opacity: 1, y: 0, scale: 1 },
                  }}
                >
                  <motion.div
                    className="gallery-item position-relative overflow-hidden rounded-4 shadow-lg"
                    whileHover={{ scale: 1.05 }}
                    transition={{ duration: 0.4 }}
                  >
                    <img
                      src={img.src}
                      alt={img.caption}
                      className="w-100"
                      style={{
                        height: "auto",
                        minHeight: "200px",
                        objectFit: "cover",
                      }}
                    />
                    <div className="gallery-overlay position-absolute bottom-0 start-0 w-100 p-4 text-white">
                      <h5 className="fw-bold">{img.caption}</h5>
                    </div>
                  </motion.div>
                </motion.div>
              ))}
            </motion.div>
          </div>
        </section>

        {/* ==================== FAQs SECTION ==================== */}
        <section id="faqs" className="py-5 bg-black text-white">
          <div className="container">
            {/* Title */}
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="text-center mb-5"
            >
              <h3 className="display-5 fw-bold mb-3">
                Frequently Asked Questions
              </h3>
              <p className="">Find answers to common questions about Encanto by Lansum & MK Realty, including project location, apartment configurations, amenities, possession timelines, and investment potential in Puppalaguda, Hyderabad.</p>
            </motion.div>

            {/* Centered Accordion - col-lg-8 */}
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <motion.div
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.8, delay: 0.3 }}
                  className="accordion accordion-flush"
                  id="faqAccordion"
                >
                  {faqs.map((faq, index) => (
                    <motion.div
                      key={index}
                      className="accordion-item bg-transparent border-bottom border-secondary"
                      initial={{ opacity: 0, x: -50 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      viewport={{ once: true }}
                      transition={{ delay: index * 0.1 }}
                    >
                      <h2 className="accordion-header" id={`heading${index}`}>
                        <button
                          className="accordion-button collapsed bg-black fw-bold shadow-none faq-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#collapse${index}`}
                          aria-expanded="false"
                          aria-controls={`collapse${index}`}
                          style={{ color: "#bb6943" }} // Main color for question text
                        >
                          {faq.question}
                        </button>
                      </h2>
                      <div
                        id={`collapse${index}`}
                        className="accordion-collapse collapse"
                        aria-labelledby={`heading${index}`}
                        data-bs-parent="#faqAccordion"
                      >
                        <div className="accordion-body text-white-50 bg-dark bg-opacity-50 py-4">
                          {faq.answer}
                        </div>
                      </div>
                    </motion.div>
                  ))}
                </motion.div>
              </div>
            </div>
          </div>
        </section>

        {/* ==================== CONTACT SECTION ==================== */}
        <section
          id="contact"
          className="contact-section position-relative py-5"
        >
          {/* Background Image */}
          <div className="contact-bg"></div>
          <div className="contact-overlay"></div>

          <div className="container position-relative">
            {/* Title - Slides up */}
            <motion.div
              initial={{ opacity: 0, y: 80 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.9, ease: "easeOut" }}
              className="text-center mb-5 text-white"
            >
              <h3 className="display-5 fw-bold mb-3">Get in Touch</h3>
              <p className="">
                Connect with our sales team to explore premium 3 & 4 BHK luxury apartments at Encanto in Puppalaguda, Hyderabad. Enquire today for floor plans, pricing details, and a personalized site visit.
              </p>
            </motion.div>

            <div className="row align-items-center g-5">
              {/* Left Side - Image + Points */}
              <motion.div
                className="col-lg-7"
                initial={{ opacity: 0, y: 100 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 1, delay: 0.2, ease: "easeOut" }}
              >
                <motion.img
                  src={ContactImage}
                  alt="Encanto Hyderabad luxury residential project"
                  className="img-fluid rounded-4 shadow-lg mb-5"
                  style={{
                    maxHeight: "600px",
                    objectFit: "cover",
                    width: "100%",
                  }}
                  initial={{ opacity: 0, y: 60 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 1, delay: 0.4 }}
                />

                {/* Three Key Points - Staggered slide up */}
                <motion.div
                  initial={{ opacity: 0, y: 60 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.9, delay: 0.6 }}
                >
                  <ul className="list-unstyled">
                    {[
                      {
                        icon: "fa-map-marker-alt",
                        text: "Prime location in the city's power corridor with excellent connectivity",
                      },
                      {
                        icon: "fa-gem",
                        text: "World-class amenities including infinity pool, spa, clubhouse & sky lounge",
                      },
                      {
                        icon: "fa-shield-alt",
                        text: "24/7 multi-layer security and dedicated concierge services",
                      },
                    ].map((point, index) => (
                      <motion.li
                        key={index}
                        className="d-flex align-items-start mb-4"
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{
                          duration: 0.7,
                          delay: 0.8 + index * 0.2,
                          ease: "easeOut",
                        }}
                      >
                        <i
                          className={`fa ${point.icon} fa-lg me-3 text-main mt-3`}
                        ></i>
                        <span className=" text-white-50">{point.text}</span>
                      </motion.li>
                    ))}
                  </ul>
                </motion.div>
              </motion.div>

              {/* Right Side - Form Card */}
              <motion.div
                className="col-lg-5"
                initial={{ opacity: 0, y: 100 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 1, delay: 0.4, ease: "easeOut" }}
              >
                <motion.div
                  className="bg-dark bg-opacity-75 p-5 rounded-4 shadow-lg"
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.6 }}
                >
                  <h4 className="fw-bold text-white mb-3">Enquire Now</h4>

                  <Form
                    type="full"
                    onSuccess={() => {
                      alert(
                        "Thank you! Your enquiry has been submitted. We'll contact you soon."
                      );
                    }}
                  />

                  <hr className="border-secondary opacity-25 my-4" />

                  <div className="text-center">
                    <p className="text-white-50 mb-2">
                      Speak to our sales team directly:
                    </p>
                    <h5 className="text-white fw-bold">
                      <i className="fa fa-phone me-3 text-main"></i>
                      <a
                        href="tel:+919652389333"
                        className="text-white text-decoration-none hover-underline"
                      >
                        +91 96523 89333
                      </a>
                    </h5>
                  </div>
                </motion.div>
              </motion.div>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      {/* Footer */}
      <section className="bg-dark">
        <footer className="py-5 container text-light">
          <div className="text-center mb-4">
            <img
              src={Logo}
              alt="Encanto by Lansum & MK Realty logo"
              className="img-fluid"
              style={{ width: "140px" }}
            />
          </div>

          <p className="text-center mb-4">
            © 2025 Encanto. All Rights Reserved.
          </p>

          <small className="mb-0 disclaimer-text text-white-50 fs-7 text-center lh-lg">
            Disclaimer: This website is not an official site of the project and
            is only an informational website managed by a RERA authorized real
            estate agent. Encanto is a RERA registered project. Authorized
            Channel Partner | Channel Partner RERA Number: Coming Soon | Project
            RERA Number: Coming Soon. The prices mentioned on this website are
            subject to change without prior notice and availability of
            properties is not guaranteed. All images shown are for
            representation purposes only and may not depict the actual property.
            We may share your data with the RERA registered developer for
            further processing as required. We may also send updates and
            information to the mobile number/email provided by you. All rights
            reserved. The content, design, and information presented on this
            website are protected by copyright and intellectual property laws.
            Unauthorized use or reproduction is strictly prohibited. For the
            most accurate and updated information regarding pricing,
            availability, specifications, and other details, please contact us
            directly using the information provided on this website.
          </small>

          {/* <div className="text-center mt-4">
            <small className="text-white-50">
              Developed with <i className="fa fa-heart text-danger"></i> for
              luxury living
            </small>
          </div> */}
        </footer>
      </section>

      {/* ✅ WhatsApp Floating Button */}
      <motion.a
        href={whatsappLink}
        target="_blank"
        rel="noreferrer"
        className="whatsapp-fab"
        initial={{ y: 0 }}
        animate={{ y: [-5, -15, -5] }}
        transition={{ repeat: Infinity, duration: 2 }}
      >
        <div className="whatsapp-inner d-flex flex-column align-items-center justify-content-center">
          {/* Text above Icon */}
          <p className="whatsapp-text mb-1 text-style">
            WhatsApp For More Information
          </p>

          {/* Official WhatsApp Icon (SVG) */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path
              d="M20.52 3.48A11.86 11.86 0 0 0 12 .5a11.88 11.88 0 0 0-8.44 3C.96 6.5.4 9.86 1.5 12.9l-1 3.65 3.74-1.02A11.9 11.9 0 0 0 12 23.5a11.86 11.86 0 0 0 8.52-3.48A11.83 11.83 0 0 0 24 12.02a11.83 11.83 0 0 0-3.48-8.54zM12 21.5c-2.16 0-4.26-.63-6.05-1.82l-.43-.27-2.64.72.71-2.57-.28-.45A9.85 9.85 0 0 1 2 12.01 9.96 9.96 0 0 1 12 2c2.65 0 5.14 1.03 7.02 2.9A9.93 9.93 0 0 1 22 12a9.94 9.94 0 0 1-2.93 7.07A9.88 9.88 0 0 1 12 21.5zm5.22-7.3c-.28-.14-1.66-.82-1.91-.92-.26-.1-.45-.14-.63.14-.18.27-.72.92-.89 1.1-.16.18-.33.2-.61.07-.28-.14-1.17-.43-2.23-1.36a8.33 8.33 0 0 1-1.54-1.91c-.16-.27-.02-.42.12-.56.12-.12.28-.33.42-.49.14-.16.18-.27.28-.45.09-.18.05-.34-.02-.48-.07-.14-.63-1.52-.87-2.08-.23-.55-.47-.48-.63-.49-.16-.01-.34-.01-.52-.01-.18 0-.48.07-.73.34-.25.27-.96.94-.96 2.28s.99 2.64 1.13 2.82c.14.18 1.94 3.08 4.7 4.34 2.77 1.26 2.77.85 3.27.8.5-.05 1.62-.66 1.85-1.3.23-.64.23-1.18.16-1.3-.07-.12-.27-.2-.59-.34z"
              fill="white"
            />
          </svg>
        </div>
      </motion.a>
    </>
  );
}
